import {v3} from "oc-threejs/short3";
import LineRestraint from "oc-interaction/restraints2/LineRestraint";
import Commons from "oc-commons/Commons";
import Element from "../arrangement/Element";
import InteractionHandler from "./InteractionHandler";
import Scenes from "oc-threejs/Scenes";
import Cylinder from "oc-threejs/math/Cylinder";

export default class ElementLineInABoxRestraint extends LineRestraint {

    // die Box, welche das Drag-Objekt einfängt
    box: THREE.Box3;

    // die Bewegung des Objektes endet an den Grenzen der SnapBox. Muss innerhalb der Box liegen.
    snapBox: THREE.Box3;

    element: Element;
    newHeight: ?number;
    restrictToElement: boolean;

    constructor(options) {
        super(Commons.defaultsDeepSafe(options, {
            line: new THREE.Line3(
                options.snapBox.clampPoint(options.box.grid(v3(0.5, 0, 0.5))),
                options.snapBox.clampPoint(options.box.grid(v3(0.5, 1, 0.5)))),
            radius: Number.POSITIVE_INFINITY
        }));
        this.box = options.box;
        this.snapBox = options.snapBox;
        this.element = options.element;
        this.newHeight = options.newHeight || null;
        this.restrictToElement = options.restrictToElement;
    }

    raycastLocal(ray: THREE.Ray): ?THREE.Vector3 {
        const p = ray.intersectBox(this.box);
        if (!p) {
            return null;
        }
        if (this.interieur.canFlip) {
            if (APP.arrangement.isSchwebetuerOrShoji()) {
                const wallNames = {wallLeft: false, wallRight: false};
                _.forEach(wallNames, (wallValue, wallIndex) => {
                    wallNames[wallIndex] = (
                            (this.element[wallIndex].isInner && this.element[wallIndex].product.Artikelnummer === 'Trennwand') ||
                            (!this.element[wallIndex].isInner && this.element[wallIndex].product.Artikelnummer !== 'Trennwand')
                        );
                });
                if (!wallNames.wallLeft && !wallNames.wallRight) {
                    return null;
                }
            }
            this.setFlipSide(p);
        }
        return super.raycastLocal(ray);
    }

    setFlipSide(p) {
        const middle = (this.box.max.x + this.box.min.x) / 2;
        this.interieur.flipSide = p.x < middle ? 0 : 1;
    }

    onEnter(real) {
        if (this.restrictToElement) {
            return;
        }
        if (this.newHeight != null) {
            this.interieur.size.y = this.newHeight;
        }
        if (this.interieur.element === this.element) {
            return;
        }
        InteractionHandler.attachToElement(this.dragObject3d, this.element);
    }

    onLeave(real) {
        if (this.restrictToElement) {
            return;
        }
        if (!real) {
            return;
        }
        InteractionHandler.detachFromElement(this.dragObject3d);
    }

    get interieur() {
        return this.dragObject3d.vsData;
    }

    createDebugVisualization() {
        const group = new THREE.Group();
        group.add(Debugs.box(this.box, STAGE.settings.dragDrop.restraintsDebugColor,true));
        return group;
    }

}
